module.exports = __webpack_public_path__ + "rateplan-tag.png?9a5c71e789c666614130ecfd4b4b7e4f";